<template>
  <div class="ma-4">
    <ClientNav class="hideOnPrint" />
    <v-card>
      <v-card-title style="background-color: #2b3990">
        <span class="headline white--text">{{ titleForm }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Goal" v-model="newGoal" :readonly="readonly">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="3">
              <v-text-field
                v-model="newPurpose"
                label="Purpose"
                :readonly="readonly"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field
                v-model="newType"
                label="Type"
                :readonly="readonly"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-select
                v-model="newServiceCodes"
                label="Service Code"
                :items="codes"
                item-text="ServiceCode"
                item-value="_id"
                multiple
                :readonly="readonly"
              ></v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="12">
              <v-textarea
                v-model="newAssist"
                label="Staff will assist in:"
                outlined
                :readonly="readonly"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12">
              <div>Check all the following that will be needed:</div>
              <v-row>
                <v-checkbox
                  label="Transportation"
                  class="pa-4"
                  v-model="newNeeds"
                  value="Transportation"
                  :readonly="readonly"
                ></v-checkbox>
                <v-checkbox
                  label="Teaching/Prompting"
                  class="pa-4"
                  v-model="newNeeds"
                  value="Teaching/Prompting"
                  :readonly="readonly"
                ></v-checkbox>
                <v-checkbox
                  label="Supervision"
                  class="pa-4"
                  v-model="newNeeds"
                  value="Supervision"
                  :readonly="readonly"
                ></v-checkbox>
                <v-checkbox
                  label="Scheduling"
                  class="pa-4"
                  v-model="newNeeds"
                  value="Scheduling"
                  :readonly="readonly"
                ></v-checkbox>
                <v-checkbox
                  label="Other"
                  class="pa-4"
                  v-model="newNeeds"
                  value="Other"
                  :readonly="readonly"
                ></v-checkbox>
              </v-row>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <v-textarea
                v-model="newProvider"
                label="Provided By"
                outlined
                :readonly="readonly"
              ></v-textarea>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <v-textarea
                v-model="newInstructions"
                label="Instructions"
                outlined
                :readonly="readonly"
              ></v-textarea>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <v-textarea
                v-model="newChanged"
                label="We will know the supports need to be changed if:"
                outlined
                :readonly="readonly"
              ></v-textarea>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <v-textarea
                v-model="newReviewNotes"
                label="Review Notes"
                outlined
                :readonly="readonly"
              ></v-textarea>
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newStartDate"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    :readonly="readonly"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newStartDate"
                  no-title
                  scrollable
                  :readonly="readonly"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newEndDate"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    :readonly="readonly"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newEndDate"
                  no-title
                  scrollable
                  :readonly="readonly"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu2 = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu2.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newReviewDate"
                    label="Review Date"
                    prepend-icon="mdi-calendar"
                    :readonly="readonly"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newReviewDate"
                  no-title
                  scrollable
                  :readonly="readonly"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu3 = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu3.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12">
              <v-checkbox
                :readonly="readonly"
                v-model="sign"
                label="Signature"
                @click="addSignature()"
                >Signature</v-checkbox
              >
              <v-text-field
                :readonly="readonly"
                v-if="sign == true"
                v-model="newSignature"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3">
              <v-select
                label="Status"
                :items="status"
                v-model="active"
                :readonly="readonly"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="white--text"
          color="#259647"
          @click="addSupport()"
          v-if="$route.params.action === 'add' && !isAuditorRole"
          :readonly="readonly"
          >Save</v-btn
        >
        <v-btn
          fab
          small
          @click="printItem()"
          class="mr-8 mb-2 white--text"
          color="#2b6993"
          elevation="4"
          v-if="$route.query.new"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="updateSupport()"
          v-if="$route.query.new && !isAuditorRole"
          >Update</v-btn
        >
         <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>

    <Foot class="hideOnPrint" />

    <div id="printItem">
      <h2 class="text-center ma-3">Support Strategy</h2>
      <v-row>
        <v-col cols="12" sm="12" md="3">
          <h3>Goal</h3>
          <div>
            {{ newGoal }}
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="3">
          <h3>Purpose</h3>
          {{ newPurpose }}
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="newType" label="Type"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="newServiceCodes"
            label="Service Code"
            :items="codes"
            item-text="ServiceCode"
            item-value="ServiceCode"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12">
          <h3>Staff will assist in:</h3>
          <div>
            {{ newAssist }}
          </div>
        </v-col>
        <v-col cols="12" sm="12">
          <div>Check all the following that will be needed:</div>
          <v-row>
            <v-checkbox
              label="Transportation"
              class="pa-4"
              v-model="newNeeds"
              value="Transportation"
            ></v-checkbox>
            <v-checkbox
              label="Teaching/Prompting"
              class="pa-4"
              v-model="newNeeds"
              value="Teaching/Prompting"
            ></v-checkbox>
            <v-checkbox
              label="Supervision"
              class="pa-4"
              v-model="newNeeds"
              value="Supervision"
            ></v-checkbox>
            <v-checkbox
              label="Scheduling"
              class="pa-4"
              v-model="newNeeds"
              value="Scheduling"
            ></v-checkbox>
            <v-checkbox
              label="Other"
              class="pa-4"
              v-model="newNeeds"
              value="Other"
            ></v-checkbox>
          </v-row>
        </v-col>
        <v-col class="d-flex" cols="12">
          <v-textarea
            v-model="newProvider"
            label="Provided By"
            outlined
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <h3>Instruction</h3>
          <div>
            {{ newInstructions }}
          </div>
        </v-col>
        <v-col cols="12">
          <h3>We will know the supports need to be changed if:</h3>
          <div>
            {{ newChanged }}
          </div>
        </v-col>
        <v-col cols="12">
          <h3>Review Notes</h3>
          <div>
            {{ newReviewNotes }}
          </div>
        </v-col>

        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="newStartDate"
            label="Start Date"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="newEndDate"
            label="End Date"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="newReviewDate"
            label="Review Date"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </v-col>
        <br /><br />

        <v-col cols="12" sm="12">
          <v-checkbox v-model="sign" label="Signature" @click="addSignature()"
            >Signature</v-checkbox
          >
          <v-text-field
            v-if="sign == true"
            v-model="newSignature"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <v-select label="Status" :items="status" v-model="active"> </v-select>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import ClientNav from "@/components/ClientNav";
import Foot from "@/components/Footer";
import axios from "axios";
import moment from "moment";

const url = require("../../../client_config/config").url;

export default {
  components: {
    ClientNav,
    Foot,
  },
  data: () => ({
    tab: null,
    items: ["Active Support Strategy", "Disabled Support Strategy"],
    dialog: false,
    times: [
      "AM",
      "PM",
      "Bedtime",
      "6:00am",
      "6:00am",
      "7:00am",
      "8:00am",
      "9:00am",
      "10:00am",
      "11:00am",
      "12:00pm",
      "1:00pm",
      "2:00pm",
      "3:00pm",
      "4:00pm",
      "5:00pm",
      "6:00pm",
      "7:00pm",
      "8:00pm",
      "9:00pm",
      "10:00pm",
      "11:00pm",
      "12:00am",
    ],
    editSupport: false,
    newSupport: false,
    msg: false,
    signed: false,
    menu: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    status: ["Active", "Disabled"],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    userID: localStorage.getItem("userID"),
    clientID: null,
    staff: "",
    text: "",
    search: "",
    supports: [],
    tempData: [],
    disabled: [],
    providers: ["Behaviorist", "CNA", "Direct Care Staff"],
    LOA: [
      "Independent",
      "Moderate Assistance",
      "Minimal Assistance",
      "Total Assistance",
    ],
    codes: [],
    unitID: localStorage.getItem("unitID"),
    titleForm: "New Support Strategy",
    supportID: "",
    newGoal: "",
    newPurpose: "",
    newServiceCodes: [],
    newType: "",
    newAssist: "",
    newNeeds: [],
    newProvider: "",
    newInstructions: "",
    newChanged: "",
    newReviewNotes: "",
    newReviewDate: moment(new Date()).format("YYYY-MM-DD"),
    newStartDate: moment(new Date()).format("YYYY-MM-DD"),
    newEndDate: moment(new Date()).format("YYYY-MM-DD"),
    newSignature: "",
    sign: false,
    disabledList: false,
    activeList: false,
    active: "",
    editedIndex: -1,
    editedItem: {
      goal: "",
      purpose: "",
      type: "",
      assist: "",
      needs: [],
      provider: "",
      instructions: "",
      changed: "",
      reviewNotes: "",
      reviewDate: "",
      startDate: "",
      endDate: "",
      signature: "",
    },
    defaultItem: {
      goal: "",
      purpose: "",
      type: "",
      assist: "",
      needs: [],
      provider: "",
      instructions: "",
      changed: "",
      reviewNotes: "",
      reviewDate: "",
      startDate: "",
      endDate: "",
      signature: "",
    },
    isLoading: true,
    serviceItems: [
      "Activities, Attitude and Behavior",
      "Ambulation",
      "Bathing/Showering",
      "Bed Making",
      "Behavioral Management",
      "Breakfast",
    ],
    readonly: false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },
    selectedServiceCodes() {
      return this.codes.filter((code) => {
        return this.newServiceCodes.includes(code._id);
      });
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.clientID = this.$route.params.clientID;
    this.getSupports();

    if (this.$route.query?.id) {
      this.getSupportItems();
    }

    this.getUsers();
    this.getServiceCodes();
    if (
      localStorage.getItem("userRole") == "Shift Lead" ||
      localStorage.getItem("userRole") == "House Manager" ||
      localStorage.getItem("userRole") == "Program Manager" ||
      localStorage.getItem("userRole") == "Program Coordinator"
    ) {
      this.readonly = true;
    }
  },

  methods: {
    initialize() {
      this.supports = [];
    },
    viewSupport(item) {
      this.titleForm = "Viewing Support Strategy for " + item.Goal;
      this.dialog = true;
      this.editSupport = true;
      this.newSupport = false;
      this.newGoal = item.Goal;
      this.newPurpose = item.Purpose;
      this.newType = item.Type;
      this.newServiceCodes = item.ServiceCodes;
      this.newAssist = item.Assist;
      this.newNeeds = item.Needs;
      this.newProvider = item.Provider;
      this.newInstructions = item.Instructions;
      this.newChanged = item.Changed;
      this.newReviewNotes = item.ReviewNotes;
      this.newReviewDate = moment(item.ReviewDate).format("YYYY-MM-DD");
      this.newStartDate = moment(item.StartDate).format("YYYY-MM-DD");
      this.newEndDate = moment(item.EndDate).format("YYYY-MM-DD");
      this.newSignature = item.Signature;
      this.sign = item.Sign;
      this.active = item.Active;
      this.supportID = item._id;
    },
    showAdd() {
      this.titleForm = "New Support Strategy";
      this.newSupport = true;
      this.editSupport = false;
    },

    deleteSupport(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this support strategy?") &&
        this.supportDelete(id);
    },

    supportDelete(id) {
      axios.delete(`${url}/support/${id}`).then((response) => {
        this.getSupports();
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The support strategy has been deleted successfully.";
      });
    },

    getServiceCodes() {
      axios.get(`${url}/serviceCodes/client/${this.clientID}`).then((res) => {
        this.codes = res.data.serviceCodes;
      });
    },

    close() {
      this.clear();
      this.$router.go(-1);
    },

    updateSupport() {
      var req_body = {
        Goal: this.newGoal,
        Purpose: this.newPurpose,
        Type: this.newType,
        ServiceCodes: this.selectedServiceCodes,
        Assist: this.newAssist,
        Needs: this.newNeeds,
        Provider: this.newProvider,
        Instructions: this.newInstructions,
        Changed: this.newChanged,
        ReviewNotes: this.newReviewNotes,
        ReviewDate: this.newReviewDate,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Signature: this.newSignature,
        Sign: this.sign,
        Active: this.active,
      };
      console.log(req_body);
      axios
        .put(`${url}/support/${this.supportID}`, req_body)
        .then((response) => {
          console.log(req_body + " does this become undefined");
          this.getSupports();

          if (response.status == 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }
          this.msg = true;
          this.text = "The support strategy has been updated successfully.";
          this.clear();
        });
      this.close();
    },
    getSupports: function () {
      this.isLoading = true;
      axios
        .get(`${url}/support/${this.clientID}`)
        .then((res) => {
          this.supports = [];
          this.disabled = [];
          this.tempData = res.data.supports;
          for (var k = 0; k < this.tempData.length; k++) {
            if (this.tempData[k].Active == "Active") {
              this.supports.push(this.tempData[k]);
            } else {
              this.disabled.push(this.tempData[k]);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },

    getDisabled() {
      this.disabledList = true;
      this.supports = this.disabled;
    },

    addSupport: function () {
      var req_body = {
        Goal: this.newGoal,
        Purpose: this.newPurpose,
        Type: this.newType,
        ServiceCodes: this.selectedServiceCodes,
        Assist: this.newAssist,
        Needs: this.newNeeds,
        Provider: this.newProvider,
        Instructions: this.newInstructions,
        Changed: this.newChanged,
        ReviewNotes: this.newReviewNotes,
        ReviewDate: this.newReviewDate,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Signature: this.newSignature,
        Sign: this.sign,
        Active: this.active,
        ClientID: this.clientID,
      };

      axios.post(`${url}/support`, req_body).then((res) => {
        this.getSupports();
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.msg = true;
        this.text = "The new support strategy has been added successfully.";
      });
      this.close();
    },

    getUsers: function () {
      axios.get(`${url}/users`).then(async (res) => {
        this.users = res.data.users;
        for (var i = 0; i < this.users.length; i++) {
          if (this.userID == this.users[i]._id) {
            this.staff = this.users[i].Name;
          }
        }
      });
    },

    addSignature: function () {
      if (!this.sign) return (this.newSignature = "");
      this.newSignature = this.staff + " - " + new Date();
      this.sign = true;
    },

    clear() {
      this.newGoal = "";
      this.newPurpose = "";
      this.newType = "";
      this.newAssist = "";
      this.newNeeds = [];
      this.newServiceCodes = [];
      this.newProvider = "";
      this.newInstructions = "";
      this.newChanged = "";
      this.newReviewNotes = "";
      this.newReviewDate = moment(new Date()).format("YYYY-MM-DD");
      this.newStartDate = moment(new Date()).format("YYYY-MM-DD");
      this.newEndDate = moment(new Date()).format("YYYY-MM-DD");
      this.newSignature = "";
      this.active = false;
      this.sign = false;
    },

    printItem() {
      document.getElementById("printItem").style.display = "block";
      window.print();
      document.getElementById("printItem").style.display = "none";
    },

    async getSupportItems() {
      try {
        this.isLoading = true;
        const response = await axios.get(
          `${url}/support/${this.$route.query.id}/item`
        );

        this.viewSupport(response.data.support);
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
  },
};
</script>
<style scoped>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

#printItem {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #printItem {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
    white-space: pre-wrap;
  }
  .hideOnPrint {
    display: none;
    border: none;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
